import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {IUpdateStatusPublicationParams} from "../models/SinglePublicationsResponse.ts";
import {IActualPublicationsResponse} from "../models/ActualPublicationsResponse.ts";


export const actualPublicationService = {
    fetchActualPublications(id: string): Promise<AxiosResponse<IActualPublicationsResponse>> {
        return $api.get(`/actual_publications/${id}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    updatePendingPublications(id: string, params: IUpdateStatusPublicationParams): Promise<AxiosResponse<string>> {
        return $api.patch(`/actual_publications/${id}`, params,
            {
                headers: {
                    Authorization: `Bearer tg-${getToken()}`
                }
            })
    },
}
